<template>
  <div class="social-drawer-mobile">
    <div class="social-category-container">
      <transition name="el-zoom-in-top" mode="out-in">
        <div class="new-post-area" v-if="newPost.length > 0" @click="$store.state.socialModule.identifier += 1">
          <div class="owner-list">
            <img width="32" height="32" v-for="(item, index) in newPost.filter(x => x.owner != null).slice(0, 3)" :key="item.id + '-new-post-area-' + index" :src="$imageus + (item.owner.image == null ? host + '/static/500x500-user.png' : item.owner.image) + '?width=200&height=200&mode=cover'" :alt="item.owner.title" />
          </div>
          <div class="text">+{{ newPost.length }} {{ $t("socialhub.newPost") }}</div>
        </div>
      </transition>

      <swiper class="right-category-wrapper" :options="swiperOption">
        <swiper-slide class="right-category-box">
          <button
            @click="
              currentHub = null;
              currentHubHasTopic = null;
            "
            class="socialhub-category"
            :style="currentHub == null ? 'background-color :' + currentEvent.color + '; color: white; border-color :' + currentEvent.color + ';' : ''"
          >
            <div class="icon-container">
              <i :style="(currentHub == null ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/socialHub.svg); background-color: ' + currentEvent.color + ';'"></i>
            </div>
            <span v-show="currentHub == null">{{ $t("socialhub.menu.hub") }}</span>
          </button>

          <button
            @click="
              currentHub = 0;
              currentHubHasTopic = true;
            "
            class="socialhub-category"
            :style="currentHub == 0 ? 'background-color :' + currentEvent.color + '; color: white; border-color :' + currentEvent.color + ';' : ''"
          >
            <div class="icon-container">
              <i :style="(currentHub == 0 ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/socialChat.svg); background-color: ' + currentEvent.color + ';'"></i>
            </div>
            <span v-show="currentHub == 0">{{ $t("socialhub.menu.questionAnswer") }}</span>
          </button>

          <button
            @click="
              currentHub = 1;
              currentHubHasTopic = null;
            "
            class="socialhub-category"
            :style="currentHub == 1 ? 'background-color :' + currentEvent.color + '; color: white; border-color :' + currentEvent.color + ';' : ''"
          >
            <div class="icon-container">
              <i :style="(currentHub == 1 ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/socialStats.svg); background-color: ' + currentEvent.color + ';'"></i>
            </div>
            <span v-show="currentHub == 1">{{ $t("socialhub.menu.voting") }}</span>
          </button>

          <button
            @click="
              currentHub = 2;
              currentHubHasTopic = null;
            "
            class="socialhub-category"
            :style="currentHub == 2 ? 'background-color :' + currentEvent.color + '; color: white; border-color :' + currentEvent.color + ';' : ''"
          >
            <div class="icon-container">
              <i :style="(currentHub == 2 ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/socialSurvey.svg); background-color: ' + currentEvent.color + ';'"></i>
            </div>
            <span v-show="currentHub == 2">{{ $t("socialhub.menu.survey") }}</span>
          </button>
        </swiper-slide>
      </swiper>
    </div>
    <div class="search-area-container">
      <div class="search-area">
        <el-dropdown>
          <el-button type="default" size="mini"> {{ getEnumsDisplay("SocialHubPostSortingType", filter.socialHubPostSortingType) }}<i class="fas fa-sort-amount-down"></i> </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) in getEnums.find(x => x.title == 'SocialHubPostSortingType').enums" :key="'post-sorting-type-' + index" :value="item.key" @click.native="currentHubSortingType = item.key" :label="item.displayName">{{ item.displayName }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="right_inner">
      <transition-group name="component-fade">
        <template v-if="currentEvent.modules.find(x => x.name == 'SocialHub') != null">
          <Social key="social-component" />
          <div class="share-block" key="share-block-component">
            <div v-if="isMentionVisible && sharepanel" v-dragscroll.x class="mention-panel">
              <div v-for="(user, index) in users" :key="index" @click="tagUser(user)" class="mention-item">
                <div :style="user.image == null ? 'background-color: f1f1f1;' : 'background-image: url(' + $imageus + user.image + '?width=200&height=200&mode=cover&background=ffffff'" class="user-image"></div>
                <p>{{ user.title }}</p>
              </div>
            </div>
            <transition name="el-zoom-in-bottom" mode="out-in">
              <div class="share-panel" v-if="sharepanel">
                <div v-if="currentEvent.socialHub.topics.length > 0" style="margin-bottom:10px; pointer-events: all;">
                  <el-select v-model="form.topic" :placeholder="$t('selectTopic')" @clear="form.topic = null" value-key="id" clearable>
                    <el-option v-for="(topic, index) in currentEvent.socialHub.topics" :key="topic.id + index" :label="topic.title" :value="topic">
                      <template>
                        <i class="fas fa-circle" :style="'color:' + topic.color"></i>
                        <span>{{ topic.title }}</span>
                      </template>
                    </el-option>
                  </el-select>
                </div>
                <textarea @keydown.enter.exact.prevent @keyup.enter.exact="post" v-model="form.postText" :disabled="loading == 'postSend'" type="textarea" rows="12" style="resize:none;" resize="none" :placeholder="$t('share')" />
                <button @click="post" :style="'background-color: ' + currentEvent.color + ';'">
                  <i :class="loading == 'postSend' ? 'fa fa-spinner spin' : 'fa fa-paper-plane'"></i>
                  {{ $t("send") }}
                </button>
              </div>
            </transition>

            <div v-if="currentEvent.modules.find(x => x.name == 'SocialHub') != null && isAttending" class="share-button" :style="'background-color: ' + currentEvent.color + ';'" @click="sharepanel == false ? (sharepanel = true) : (sharepanel = false)">
              <i :style="sharepanel == true ? 'margin-right:0px;' : ''" :class="sharepanel == false ? 'fas fa-edit' : 'fas fa-times'"></i>
            </div>
          </div>
        </template>
        <template v-else>
          <Nodata :title="$t('socialhub.nodatatitle')" :description="$t('socialhub.nodatadesc')" key="no-data" anim="social" :type="filter.type" />
        </template>
      </transition-group>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Social from "../components/event/socialHub/Social.vue";
export default {
  data() {
    return {
      axios,
      isOpen: false,
      currentHubHasTopic: this.$store.getters.getSocialTopicType,
      currentHub: this.$store.getters.getSocialType,
      currentHubSortingType: 0,
      swiperOption: {
        slidesPerView: "auto"
      },
      sharepanel: false,
      isMentionVisible: false,
      users: [],
      form: {
        id: null,
        postText: null,
        title: null,
        image: null,
        topic: null,
        session: null,
        isDraft: true,
        isAnnouncement: true,
        type: 0,
        mentions: [
          // {
          //   id: null,
          //   type: 0,
          //   color: null,
          //   title: null,
          //   image: null,
          //   fullName: null
          // }
        ]
      },
      loading: false,
      timeout: null
    };
  },
  components: {
    Social
  },
  methods: {
    handleClose() {},
    tagUser(user, post) {
      this.form.mentions.push(user);
      this.isMentionVisible = false;
      this.form.postText = this.form.postText.replace("@" + this.searchTerm, user.fullName);
      this.searchTerm = "";
      this.users = [];
    },
    async post() {
      this.loading = "postSend";
      var postText = this.form.postText;
      this.form.mentions.forEach(user => {
        if (postText.includes(user.fullName)) {
          postText = postText.replace(user.fullName, "%" + user.id + "%");
        } else {
          var fIndex = this.form.mentions.findIndex(x => x.id == user.id);
          if (fIndex != -1) {
            this.form.mentions.splice(fIndex, 1);
          }
        }
      });
      var response = await axios.post("socialhub/addorupdate", {
        ...this.form,
        postText: postText ? postText : this.form.postText
      });
      if (response.data.hasError == false) {
        this.form.postText = null;
        this.form.topic = null;
        this.form.mentions = [];
      } else {
        this.$message.error(response.data.message);
      }
      this.sharepanel = false;
      this.loading = false;
    }
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    },
    newPost() {
      return this.$store.getters.getNewPost;
    },
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentOrganisation() {
      return this.$store.getters.getOrganisation;
    },
    isAttending() {
      return this.$store.getters.getAttending;
    },
    topicType() {
      return this.$store.getters.getSocialTopicType;
    },
    type() {
      return this.$store.getters.getSocialType;
    },
    filter() {
      return this.$store.getters.getSocialHubFilter;
    }
  },
  watch: {
    currentHubSortingType: function() {
      this.$store.commit("changeSocialItemSortingType", this.currentHubSortingType);
    },
    topicType() {
      this.currentHubHasTopic = this.topicType;
    },
    type() {
      this.currentHub = this.type;
    },
    currentHubHasTopic: function() {
      this.$store.commit("changeSocialItemTopicType", this.currentHubHasTopic);
    },
    currentHub: function() {
      this.$store.commit("changeSocialItemType", this.currentHub);
    }
  }
};
</script>

<style lang="less">
.social-mobile-drawer {
  .el-drawer__body {
    overflow: hidden;
    background: white;
  }
}

.social-drawer-mobile {
  position: relative;
  height: 100%;
  overflow: hidden;

  .search-area-container {
    padding: 0 8px;
    width: 100%;
    margin-top: 0.5rem;
    .search-area {
      padding: 12px;
      margin-bottom: 0.5rem;
      height: 48px;
      width: 100%;
      max-height: 48px;
      background: #ffffff;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 12px;
      display: flex;
      justify-content: flex-end;
      .el-button {
        border: 0;
        font-style: normal;
        font-weight: 700;
        font-size: 14px !important;
        max-height: 24px;
        min-height: 24px;
        padding: 2px 6px !important;
        width: auto !important;
        span {
          display: flex;
          gap: 5px;
          align-items: center;
        }
      }
    }
  }
  .social-category-container {
    display: flex;
    background-color: white;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding-bottom: 8px;
    border-bottom: 1px solid whitesmoke;
    position: relative;
    .new-post-area {
      position: absolute;
      padding: 9px;
      cursor: pointer;
      left: 50%;
      bottom: -53px;
      z-index: 2;
      transform: translateX(-50%);
      gap: 8px;
      display: flex;
      background: #03658c;
      align-items: center;
      border-radius: 64px;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      .owner-list {
        display: flex;
        flex-direction: row;
        flex-shrink: 0;
        img {
          flex-shrink: 0;
          width: 22.5px;
          height: 22.5px;
          border-radius: 50%;
          border: 1.5px solid #ffffff;
          margin-left: -8px;
          &:first-child {
            margin-left: 0;
          }
        }
      }
      .text {
        flex-shrink: 0;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: white;
      }
    }
  }
  .right-category-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 4px;
    margin-top: 8px;
    padding-left: 6px;

    .right-category-box {
      display: flex;
      flex-direction: row;
      justify-content: space-around;

      .socialhub-category-passive {
        opacity: 0.5;
        filter: grayscale(100%);
        cursor: not-allowed !important;
        cursor: no-drop !important;
      }

      .socialhub-category {
        background: #fff;
        border: unset !important;
        padding: 8px 10px;
        border-radius: 30px;
        margin-right: 6px;
        cursor: pointer;
        font-family: "Roboto";
        color: #8c929c;
        white-space: nowrap;
        display: flex;
        align-items: center;
        transition: all 0.2s ease-in-out;

        .icon-container {
          width: 25px;
          height: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          text-decoration: none;

          i {
            margin-bottom: 0px;
            display: block;
            background-position: 50%;
            background-repeat: no-repeat;
            background-size: contain;
            height: 25px;
            width: 25px;
            cursor: pointer;
            mask-repeat: no-repeat;
            mask-position: center;
          }
        }

        span {
          font-size: 14px;
          font-weight: 500;
          margin-left: 6px;
        }
      }
    }
  }
  .right_inner {
    height: calc(~"100vh - 200px");
    max-height: -webkit-fill-available;
    width: 100%;
    position: relative;
    .not-participant-show {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: -20vh;
      height: 100vh;
      text-align: center;
      padding: 0px 20px;

      i {
        font-size: 30px;
        font-size: 50px;
        color: #8c929c;
      }

      h5 {
        font-size: 20px;
        font-weight: 500;
        margin: 16px 0px 0px 0px;
        color: #292f3b;
      }

      p {
        font-size: 14px;
        font-weight: 400;
        color: #505763;

        a {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
    .share-block {
      position: absolute;
      bottom: 2rem;
      right: 0px;
      width: 100%;
      padding: 0px 16px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      transition: all 0.4s;
      z-index: 5;
      pointer-events: none;

      .mention-panel {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
        height: 60px;
        width: 100%;
        background-color: #fff;
        border-radius: 8px;
        padding: 6px 8px;
        margin-bottom: 10px;
        box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.4);
        overflow-y: hidden;
        overflow-x: hidden;
        pointer-events: all;

        .mention-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-right: 15px;
          width: auto;
          position: relative;
          cursor: pointer;

          .user-image {
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 50%;
            border: 3px solid #f1f1f1;
            width: 38px;
            height: 38px;
            display: inline-block;
            position: absolute;
          }

          p {
            font-size: 13px;
            font-weight: 500;
            margin-left: 44px;
            white-space: nowrap;
          }
        }
      }

      .share-panel {
        display: inline-block;
        position: relative;
        width: 100%;
        min-height: 200px;
        // max-height: 360px;
        background-color: white;
        margin-bottom: 25px;
        border-radius: 8px;
        box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.4);
        padding: 14px;
        transition: all 0.4s;

        &::after {
          content: " ";
          position: absolute;
          width: 0;
          height: 0;
          left: auto;
          right: 38px;
          bottom: -20px;
          border: 12px solid;
          border-color: white white transparent transparent;
        }

        textarea {
          display: block;
          width: 100% !important;
          min-height: inherit;
          max-height: 286px;
          border: none;
          font-family: "Roboto", sans-serif;
          font-size: 13px;
          pointer-events: all;

          &:focus {
            outline: none !important;
            border: none !important;
          }
        }

        button {
          width: 100%;
          margin-top: 6px;
          padding: 12px 0px;
          border-radius: 8px;
          border: none;
          background-color: #03658c;
          color: white;
          font-weight: 600;
          font-family: "Roboto", sans-serif;
          cursor: pointer;
          pointer-events: all;

          i {
            margin-right: 6px;
          }
        }
      }

      .share-button {
        background-color: #03658c;
        border-radius: 30px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 14px;
        font-weight: 500;
        max-width: 170px;
        cursor: pointer;
        transition: all 0.4s;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
        pointer-events: all;

        span {
          transition: all 0.4s;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/SocialDrawer.vue